import React from 'react';
import { Box } from '@material-ui/core';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@this/shared/ui/data_displays/table';
import type ReceiptTripDownload from '@this/domain/accounting/receipts/receipt_trip_download';

type Props = {
  receiptTripDownloads: ReceiptTripDownload[];
};

const ReceiptTripList = ({ receiptTripDownloads }: Props) => {
  return (
    <Box my={1} mx={1} style={{ overflow: 'auto', maxHeight: 'calc(100vh - 400px)' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ minWidth: '100px' }}>旅程番号</TableCell>
            <TableCell style={{ minWidth: '120px' }}>請求書番号</TableCell>
            <TableCell style={{ minWidth: '200px' }}>法人名</TableCell>
            <TableCell align="right" style={{ minWidth: '100px' }}>
              旅程金額
            </TableCell>
            <TableCell style={{ minWidth: '100px' }}>領収書ステータス</TableCell>
            <TableCell style={{ minWidth: '100px' }}>フラグ</TableCell>
            <TableCell style={{ minWidth: '120px' }}>領収書番号</TableCell>
            <TableCell style={{ minWidth: '160px' }}>領収書発行日時</TableCell>
            <TableCell style={{ minWidth: '120px' }}>ユーザー</TableCell>
            <TableCell style={{ minWidth: '200px' }}>送信先アドレス</TableCell>
            <TableCell style={{ minWidth: '200px' }}>宛名</TableCell>
            <TableCell align="right" style={{ minWidth: '120px' }}>
              領収書金額
            </TableCell>
            <TableCell style={{ minWidth: '100px' }}>料金の内訳</TableCell>
            <TableCell style={{ minWidth: '100px' }}>手配手数料</TableCell>
            <TableCell style={{ minWidth: '150px' }}>但書</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {receiptTripDownloads.map(data => (
            <TableRow hover key={data.id}>
              <TableCell>{data.tripId}</TableCell>
              <TableCell>{data.invoiceNumber}</TableCell>
              <TableCell>{data.organizationName}</TableCell>
              <TableCell align="right">{Number(data.totalPrice ?? 0).toLocaleString()}円</TableCell>
              <TableCell>{data.receiptStatusText}</TableCell>
              <TableCell>{data.receiptFlagText}</TableCell>
              <TableCell>{data.receiptNumber}</TableCell>
              <TableCell>{data.receiptIssueDate}</TableCell>
              <TableCell>{data.userName}</TableCell>
              <TableCell>{data.email}</TableCell>
              <TableCell>{data.name}</TableCell>
              <TableCell align="right">{Number(data.receiptAmount ?? 0).toLocaleString()}円</TableCell>
              <TableCell>{data.includePriceBreakdown ? 'あり' : 'なし'}</TableCell>
              <TableCell>{data.includeFee ? 'あり' : 'なし'}</TableCell>
              <TableCell>{data.priceRemarksTypeText}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ReceiptTripList;
